import React from 'react'
import { useTranslation } from 'react-i18next'

const StudioHeroBanner = () => {
  const { t } = useTranslation()

  return (
    <section className="relative bg-gradient-to-r from-primary-800 to-primary-800 text-white py-20">
      <div className="container section-padding">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">
            {t('studio.hero.title')}
          </h1>
          <p className="text-xl md:text-2xl text-primary-100 leading-relaxed">
            {t('studio.hero.subtitle')}
          </p>
        </div>
      </div>
      
    </section>
  )
}

export default StudioHeroBanner 